import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const ContributorIdOfNoPeopleGroup = 'contributor-id-of-no-people';

export type HydratedUser = {
	id: string;
	name: string;
	picture: string;
};

export type HydratedWork = {
	id: string;
	name: string;
	url?: string;
	hierarchyLevel?: number;
	/** Jira issue type icon URL from issue search (when present). */
	issueTypeAvatarUrl?: string;
	/** Jira issue type name for tooltip/accessibility. */
	issueTypeName?: string;
};

export type HydratedCapacityPlanningDataResult = {
	usersByAccountId: Map<string, HydratedUser>;
	workById: Map<string, HydratedWork>;
};

export type CapacityPlanningAction = ActionRendererFor<
	typeof ActionKeys.ManageCapacityPlan
>['actions'][number];

export type CapacityPlanningActionsByIndex = {
	actionsByWorkId: Map<string, CapacityPlanningAction[]>;
	actionsByContributorId: Map<string, CapacityPlanningAction[]>;
};

export type CapacityPlanningIds = {
	contributorIds: string[];
	workIds: string[];
};

export const VIEW_TYPE = { PEOPLE: 'PEOPLE', WORK: 'WORK' } as const;

export type CapacityPlanningViewType = (typeof VIEW_TYPE)[keyof typeof VIEW_TYPE];
